import { styled, Button as MuiButton } from "@mui/material";

export const Button = styled(MuiButton)(({ theme }) => {
    return {
        textTransform: "capitalize",
    };
});
